/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createPresetManager(
  state,                   
  initialPresets = {}      
) {
  const presets = initialPresets;
  function updateSprayParams(
    newRadius, 
    newDensity, 
    newSpeed, 
    newSpeedFactor, 
    presetKey, 
    dripsEnabled, 
    consumption, 
    preset, 
    canId, 
    newColor, 
    newCansData
  ) {
    state.dynamicRadius = newRadius;          
    state.dynamicDensity = newDensity;        
    state.dynamicSpeed = newSpeed;            
    state.dynamicSpeedFactor = newSpeedFactor;
    state.currentPreset = presetKey || state.currentPreset;
    state.enableDrips = dripsEnabled || false;
    state.paintConsumption = consumption || state.paintConsumption || 1;
    state.presetConfig = preset || state.presetConfig;
    if (newCansData) {
      state.syncPaintState(newCansData);
    }
    if (canId) {
      state.config.activeCanId = canId;
      const activeCan = state.cansData.find(c => c.id === canId);
      if (activeCan) {
        if (newColor) {
          state.config.currentColor = newColor;
          const canIndex = state.cansData.findIndex(c => c.id === canId);
          if (canIndex !== -1) {
            state.cansData[canIndex].color = newColor;
          }
        } else if (activeCan.color) {
          state.config.currentColor = activeCan.color;
        } else {
          state.config.currentColor = '#ff3366';
        }
        state.config.paintLeft = typeof activeCan.paintLeft === 'number' ? activeCan.paintLeft : state.config.paintMax;
      }
    }
    state.config.sprayRadius = state.dynamicRadius;    
    state.config.dotsPerTick = state.dynamicDensity;  
    state.config.lineScale = state.dynamicSpeed;      
    state.config.speedFactor = state.dynamicSpeedFactor;
    if (typeof state.onUIUpdate === 'function') {
      state.onUIUpdate();
    }
  }
  return { 
    updateSprayParams 
  };
}
